module.exports = __webpack_public_path__ + "CopingStyle1.png?516444d7a4feda5c2142ab45b88cc37b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/CopingStyle1.png
// module id = 124
// module chunks = 0